import styled, { css } from 'styled-components'

export const LogoWrap = styled.div`
    position: relative;
    z-index: 1;
    a {
        display: flex;
        align-items: center;
    }
    ${props => props.transparentBG && css`
        .dark-logo{
            display: none;
        }
        .white-logo{
            display: block;
        }
    `}
    ${props => !props.transparentBG && css`
        .dark-logo{
            display: block;
        }
        .white-logo{
            display: none;
        }
    `}
`;